import React, { Component}  from 'react';

import './TipBox.css';

class TipBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: props.visible
    };
  }

  render() {
    return(
      <div className={`tip--container ${this.state.isVisible? 'not-display' : ''}`}> 
        <span className="tip--title">Tips</span>
        <span className="tip--content">{this.props.tipsContent}</span>
      </div>
  );}
}

export default TipBox;



// WEBPACK FOOTER //
// ./src/components/TipBox.js